import { render, staticRenderFns } from "./dashboard-outbound.vue?vue&type=template&id=d33a8804"
import script from "./dashboard-outbound.vue?vue&type=script&lang=js"
export * from "./dashboard-outbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports